export class EditCommodityModel {
  constructor(commodity: any) {
    if (commodity !== null) {
      this.isNew = false;
      this.originalCommodityCode = commodity.commodityCode;
      this.commodityCode = commodity.commodityCode;
      this.description = commodity.description;
      this.count = commodity.count;
      this.chargeQuantity = +commodity.chargeQuantity;
      this.countUnit = commodity.countUnit;
      this.volume = commodity.volume;
      this.volumeUnit = commodity.volumeUnit;
      this.weight = commodity.weight;
      this.weightUnit = commodity.weightUnit;
      this.fixFor = commodity.fixFor;
      this.rate = commodity.rate;
      this.fixRate = commodity.fixRate;
      this.charge = commodity.charge;
      this.fixRate = commodity.fixRate;
      this.fixDollars = commodity.fixDollars;
    }
  }

  isNew: boolean = true;
  orderHeaderNumber?: number;
  originalCommodityCode?: string;
  commodityCode?: string;
  description?: string;
  count?: number = 0;
  chargeQuantity?: number = 0;
  countUnit?: string;
  volume?: number = 0;
  volumeUnit?: string;
  weight?: number = 0;
  weightUnit?: string;
  fixFor?: number;
  rate?: number = 0;
  fixRate?: boolean;
  charge?: number = 0;
  fixDollars?: boolean = false;
}
